import type {SyntheticEvent} from 'react';

/**
 * Prevent default event
 * @param event Event
 * @param args Arguments
 *
 * @example
 * ```ts
 * preventDefault(event);
 * ```
 */
export const preventDefault = <E extends SyntheticEvent | Event>(event: E) => {
	event.preventDefault();
};

export default preventDefault;
